export default "__VITE_ASSET__DwyU4EBG__"